import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
} from "@/components/ui/command";
import api from "@/lib/api";
import { SearchResultGroup } from "@/components/search/SearchResultGroup";
import { SEARCH_RESULT_GROUPS } from "@/components/search/searchResultGroups";

export const GlobalSearchDialog = ({ open, onOpenChange }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!query || query.trim().length < 1) {
      setResults(null);
      return;
    }
    const timeout = setTimeout(async () => {
      try {
        const res = await api.get("/search", { params: { q: query } });
        setResults(res.data);
      } catch {
        setResults(null);
      }
    }, 250);
    return () => clearTimeout(timeout);
  }, [query]);

  const go = (path) => {
    onOpenChange(false);
    setQuery("");
    navigate(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput
        placeholder="Search students, parents, instructors, classes, vehicles..."
        value={query}
        onValueChange={setQuery}
        data-testid="global-search-input"
      />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        {SEARCH_RESULT_GROUPS.map((group) => (
          <SearchResultGroup
            key={group.key}
            heading={group.heading}
            icon={group.icon}
            items={results?.[group.key]}
            renderLabel={group.renderLabel}
            onSelectItem={(item) => go(group.getPath(item))}
          />
        ))}
      </CommandList>
    </CommandDialog>
  );
};
